/* eslint-disable import/prefer-default-export */

import {
  addDays,
  startOfWeek,
  endOfWeek,
  addWeeks,
  startOfMonth,
  endOfMonth,
  addMonths,
} from 'date-fns';

// eslint-disable-next-line no-unused-vars
import { DefinedRange } from './types';

const getDefaultRanges = (date: Date): DefinedRange[] => [
  {
    label: 'Dnes',
    startDate: date,
    endDate: date,
  },
  {
    label: 'Včera',
    startDate: addDays(date, -1),
    endDate: addDays(date, -1),
  },
  {
    label: 'Tento týždeň',
    startDate: startOfWeek(date),
    endDate: endOfWeek(date),
  },
  {
    label: 'Minulý týždeň',
    startDate: startOfWeek(addWeeks(date, -1)),
    endDate: endOfWeek(addWeeks(date, -1)),
  },
  {
    label: 'Posledných 7 dní',
    startDate: addWeeks(date, -1),
    endDate: date,
  },
  {
    label: 'Tento mesiac',
    startDate: startOfMonth(date),
    endDate: endOfMonth(date),
  },
  {
    label: 'Minulý mesiac',
    startDate: startOfMonth(addMonths(date, -1)),
    endDate: endOfMonth(addMonths(date, -1)),
  },
];

export const defaultRanges = getDefaultRanges(new Date());
